import React from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import { useStyles, useToolbarStyles } from './EstoqueInsumoMovimentacaoPorInsumoTableStyles';
import theme from '../../../../theme';
import Grid from '@material-ui/core/Grid';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import Chart from "react-apexcharts";


function EstoqueMovimentacoeMovimentacaoPorInsumoTable(props) {
  const { movimentacoes, setMovimentacoes, titulo, mensagemSemDados} = props;
  const classes = useStyles();


  const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" color="textSecondary" gutterBottom id='tituloTabelaEstoqueMovimentacao'>
          { titulo }
        </Typography>
      </Toolbar>
    );
  };

  return (
    <Paper
      className={classes.root}
      elevation={3}
    >
      <Grid
        container
      >
        <Grid
          item
          md={12}
          xs={12}
        >
          <EnhancedTableToolbar numSelected={0} />
        </Grid>
        {
          movimentacoes && movimentacoes.result && movimentacoes.result.length <= 0 &&
          <Grid
            item
            md={12}
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <img
              height={'170px'}
              width={'220px'}
              alt="Logo"
              src={"/images/erroGeral.png"}
              style={{
                marginTop: 10,
                marginBottom: 10
              }}
            />
          </Grid>
        }
        {
          movimentacoes && movimentacoes.result && movimentacoes.result.length <= 0 &&
          <Grid
            item
            md={12}
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Typography className={classes.title} variant="h4" color="textSecondary" gutterBottom id='tituloTabelaEstoqueMovimentacao'>
              { mensagemSemDados }
            </Typography>
          </Grid>
        }
        {
          movimentacoes && movimentacoes.result && movimentacoes.result.length > 0 &&
          <Grid
            item
            md={12}
            xs={12}
          >
            <TableContainer className={classes.containerTable}>
              <Table
                stickyHeader
                aria-label="sticky table"
                size={'small'}
              >
                <TableHead
                >
                  <TableRow
                  >
                    <TableCell
                      key={'label_insumo'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                    </TableCell>
                    <TableCell
                      key={'label_descricao_insumo'}
                      align={'left'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Insumo'}
                    </TableCell>

                    <TableCell
                      key={'label_quantidade_anterior'}
                      align={'right'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Qtd inicial'}
                    </TableCell>
                    <TableCell
                      key={'label_quantidade'}
                      align={'right'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Qtd final'}

                    </TableCell>
                    <TableCell
                      key={'label_quantidade'}
                      align={'right'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Qtd movimentada'}

                    </TableCell>
                    <TableCell
                      key={'label_quantidade_atual'}
                      align={'right'}
                      className={clsx({
                        [classes.cellGeralCabecalho]: true
                      })}
                    >
                      {'Qtd atual'}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {movimentacoes.result.map((movimentacao, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      >
                        <TableCell
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          <Chart
                            options={{
                              chart: {
                                width: 10,
                                height: 10,
                                sparkline: {
                                  enabled: true
                                },
                                type: 'radialBar',
                              },
                              dataLabels: {
                                enabled: false
                              },
                              legend: {
                                show: false
                              },
                              plotOptions: {
                                radialBar: {
                                  hollow: {
                                    margin: 0,
                                    size: '50%'
                                  },
                                  track: {
                                    margin: 0
                                  },
                                  dataLabels: {
                                    show: false
                                  }
                                },

                              },

                              colors: [theme.palette.primary.main],
                            }}
                            type={'radialBar'}
                            series={
                              [
                                (movimentacao.meta ? movimentacao.meta : 0).toFixed(2)
                              ]
                            }
                            height={50}
                            width={50}
                          />
                        </TableCell>
                        <TableCell
                          align={'left'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {movimentacao.estoqueInsumo && movimentacao.estoqueInsumo.insumo && movimentacao.estoqueInsumo.insumo.descricao}
                        </TableCell>
                        <TableCell
                          align={'right'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            movimentacao.quantidadeInicial
                          }
                        </TableCell>
                        <TableCell
                          align={'right'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            movimentacao.quantidadeFinal
                          }
                        </TableCell>
                        <TableCell
                          align={'right'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            typeof movimentacao.quantidadeFinal === 'number' &&
                            typeof movimentacao.quantidadeInicial === 'number' &&
                            movimentacao.quantidadeFinal - movimentacao.quantidadeInicial
                          }
                        </TableCell>
                        <TableCell
                          align={'right'}
                          className={clsx({
                            [classes.cellGeral]: true
                          })}
                        >
                          {
                            movimentacao.estoqueInsumo && movimentacao.estoqueInsumo.quantidade
                          }
                        </TableCell>

                      </TableRow>

                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        }
      </Grid>
    </Paper>
  );
};

export default EstoqueMovimentacoeMovimentacaoPorInsumoTable;
